import React, { useState, useEffect, useCallback, useRef } from 'react';
import { io } from 'socket.io-client';

const TIME_RANGES = [
  { label: '5 min',   from: 'now-5m',  to: 'now' },
  { label: '15 min',  from: 'now-15m', to: 'now' },
  { label: '30 min',  from: 'now-30m', to: 'now' },
  { label: '1 hour',  from: 'now-1h',  to: 'now' },
  { label: '3 hours', from: 'now-3h',  to: 'now' },
  { label: '6 hours', from: 'now-6h',  to: 'now' },
  { label: '12 hours',from: 'now-12h', to: 'now' },
  { label: '24 hours',from: 'now-24h', to: 'now' },
  { label: '7 days',  from: 'now-7d',  to: 'now' },
];
const DEFAULT_TIME = TIME_RANGES[7];
const API_URL = process.env.REACT_APP_API_URL;

const styles = {
  toastContainer: { position: 'fixed', top: '64px', right: '1rem', zIndex: 1000, display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '360px' },
  toast: { background: '#1a1d27', border: '1px solid #2a2d3e', borderRadius: '6px', padding: '0.75rem 1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.4)', cursor: 'pointer', animation: 'slideIn 0.25s ease-out' },
  toastTitle: { color: '#e0e0e0', fontWeight: 700, fontSize: '0.85rem', marginBottom: '0.2rem' },
  toastBody: { color: '#aaa', fontSize: '0.78rem' },
  app: { minHeight: '100vh', background: '#0f1117', display: 'flex', flexDirection: 'column' },
  nav: {
    background: '#1a1d27', borderBottom: '1px solid #2a2d3e',
    padding: '0 1.5rem', height: '56px', display: 'flex',
    alignItems: 'center', justifyContent: 'space-between',
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
  },
  navLeft: { display: 'flex', alignItems: 'center', gap: '1rem' },
  logo: { color: '#4fc3f7', fontWeight: 700, fontSize: '1.1rem', letterSpacing: '0.05em', whiteSpace: 'nowrap' },
  customerName: { color: '#888', fontSize: '0.9rem', borderLeft: '1px solid #2a2d3e', paddingLeft: '1rem', whiteSpace: 'nowrap' },
  navRight: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
  navBtn: {
    background: 'transparent', border: '1px solid #2a2d3e', color: '#aaa',
    padding: '0.4rem 0.9rem', borderRadius: '4px', cursor: 'pointer',
    fontSize: '0.85rem', transition: 'all 0.2s', whiteSpace: 'nowrap',
  },
  navBtnActive: { background: '#4fc3f7', border: '1px solid #4fc3f7', color: '#0f1117', fontWeight: 600 },
  navBtnAdmin: { background: 'transparent', border: '1px solid #f59e0b', color: '#f59e0b',
    padding: '0.4rem 0.9rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', whiteSpace: 'nowrap' },
  navBtnEval: { background: 'transparent', border: '1px solid #a78bfa', color: '#a78bfa',
    padding: '0.4rem 0.9rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', whiteSpace: 'nowrap' },
  navLinkBtn: {
    background: 'transparent', border: '1px solid #2a2d3e', color: '#aaa',
    padding: '0.4rem 0.9rem', borderRadius: '4px', cursor: 'pointer',
    fontSize: '0.85rem', textDecoration: 'none', display: 'inline-flex',
    alignItems: 'center', whiteSpace: 'nowrap',
  },
  timeSelect: {
    background: '#0f1117', border: '1px solid #2a2d3e', color: '#4fc3f7',
    padding: '0.4rem 0.6rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', outline: 'none',
  },
  divider: { width: '1px', height: '24px', background: '#2a2d3e', margin: '0 0.25rem' },
  hamburger: {
    background: 'transparent', border: '1px solid #2a2d3e', color: '#aaa',
    padding: '0.4rem 0.6rem', borderRadius: '4px', cursor: 'pointer',
    fontSize: '1.1rem', lineHeight: 1,
  },
  mobileMenu: {
    position: 'fixed', top: '56px', left: 0, right: 0, zIndex: 99,
    background: '#1a1d27', borderBottom: '1px solid #2a2d3e',
    padding: '0.75rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem',
  },
  mobileBtn: {
    background: 'transparent', border: '1px solid #2a2d3e', color: '#aaa',
    padding: '0.6rem 1rem', borderRadius: '4px', cursor: 'pointer',
    fontSize: '0.9rem', textAlign: 'left', width: '100%',
  },
  mobileBtnActive: { background: '#4fc3f7', border: '1px solid #4fc3f7', color: '#0f1117', fontWeight: 600 },
  logoutBtn: {
    background: 'transparent', border: '1px solid #2a2d3e', color: '#888',
    padding: '0.4rem 0.8rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem',
  },
  main: { marginTop: '56px', flex: 1, display: 'flex', flexDirection: 'column' },
  iframe: { border: 'none', flex: 1, width: '100%', height: 'calc(100vh - 56px)' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 56px)', color: '#888' },
  error: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 56px)', color: '#ef5350' },
  // Admin styles
  adminPanel: { padding: '1rem', maxWidth: '1000px', margin: '0 auto', width: '100%', boxSizing: 'border-box' },
  adminTitle: { color: '#4fc3f7', fontSize: '1.4rem', fontWeight: 700, marginBottom: '0.25rem' },
  adminSub: { color: '#888', fontSize: '0.85rem', marginBottom: '2rem' },
  card: { background: '#1a1d27', border: '1px solid #2a2d3e', borderRadius: '8px', padding: '1.5rem', marginBottom: '1.5rem' },
  cardTitle: { color: '#e0e0e0', fontSize: '1rem', fontWeight: 600, marginBottom: '1rem' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '0.5rem 1rem', textAlign: 'left', borderBottom: '1px solid #2a2d3e' },
  td: { color: '#e0e0e0', fontSize: '0.85rem', padding: '0.75rem 1rem', borderBottom: '1px solid #1a1d27' },
  addBtn: { background: '#4fc3f7', border: 'none', color: '#0f1117', padding: '0.5rem 1.2rem', borderRadius: '4px', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' },
  deleteBtn: { background: 'transparent', border: '1px solid #ef5350', color: '#ef5350', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  formRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' },
  label: { color: '#888', fontSize: '0.8rem', marginBottom: '0.3rem', display: 'block' },
  input: { background: '#0f1117', border: '1px solid #2a2d3e', color: '#e0e0e0', padding: '0.5rem 0.8rem', borderRadius: '4px', fontSize: '0.85rem', width: '100%' },
  select: { background: '#0f1117', border: '1px solid #2a2d3e', color: '#e0e0e0', padding: '0.5rem 0.8rem', borderRadius: '4px', fontSize: '0.85rem', width: '100%' },
  successMsg: { color: '#22c55e', fontSize: '0.85rem', padding: '0.5rem', background: 'rgba(34,197,94,0.1)', borderRadius: '4px', marginBottom: '1rem' },
  errorMsg: { color: '#ef5350', fontSize: '0.85rem', padding: '0.5rem', background: 'rgba(239,83,80,0.1)', borderRadius: '4px', marginBottom: '1rem' },
  // Eval styles
  evalPanel: { padding: '1rem', maxWidth: '1100px', margin: '0 auto', width: '100%', boxSizing: 'border-box' },
  evalTitle: { color: '#a78bfa', fontSize: '1.4rem', fontWeight: 700, marginBottom: '0.25rem' },
  evalSub: { color: '#888', fontSize: '0.85rem', marginBottom: '2rem' },
  statGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '0.75rem', marginBottom: '1.5rem' },
  statBox: { background: '#1a1d27', border: '1px solid #2a2d3e', borderRadius: '8px', padding: '1.2rem', textAlign: 'center' },
  statVal: { fontSize: '1.8rem', fontWeight: 700, color: '#4fc3f7' },
  statLbl: { fontSize: '0.75rem', color: '#888', marginTop: '0.3rem', textTransform: 'uppercase', letterSpacing: '0.05em' },
  runBtn: { background: '#a78bfa', border: 'none', color: '#0f1117', padding: '0.5rem 1.5rem', borderRadius: '4px', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem', marginLeft: '1rem' },
  faultRow: (f1) => ({
    background: f1 >= 0.9 ? 'rgba(34,197,94,0.05)' : f1 >= 0.7 ? 'rgba(245,158,11,0.05)' : 'rgba(239,83,80,0.05)'
  }),
  f1Badge: (f1) => ({
    display: 'inline-block', padding: '0.2rem 0.5rem', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 600,
    background: f1 >= 0.9 ? 'rgba(34,197,94,0.2)' : f1 >= 0.7 ? 'rgba(245,158,11,0.2)' : 'rgba(239,83,80,0.2)',
    color: f1 >= 0.9 ? '#22c55e' : f1 >= 0.7 ? '#f59e0b' : '#ef5350',
  }),
};

const HIDE_NAV_CSS = `
  header { display: none !important; }
  nav { display: none !important; }
  [class*="NavToolbar"] { display: none !important; }
  [class*="NavToolbar-actions"] { display: none !important; }
`;

function injectStyles(iframe) {
  try {
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    if (!doc) return;
    const existing = doc.getElementById('cp-hide-nav');
    if (existing) return;
    const style = doc.createElement('style');
    style.id = 'cp-hide-nav';
    style.textContent = HIDE_NAV_CSS;
    doc.head.appendChild(style);
  } catch (e) {}
}

// ── Evaluation Results Panel ──────────────────────────────────────────────────
function EvalPanel({ keycloak, onViewFault }) {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [error, setError] = useState(null);

  const fetchResults = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await fetch(`${API_URL}/evaluation/results`, {
        headers: { Authorization: `Bearer ${keycloak.token}` }
      });
      if (resp.ok) {
        setResults(await resp.json());
      } else {
        setError("No evaluation results found. Click Run Evaluation to generate.");
      }
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }, [keycloak]);

  useEffect(() => { fetchResults(); }, [fetchResults]);

  const runEval = async () => {
    setRunning(true);
    setError(null);
    try {
      const resp = await fetch(`${API_URL}/evaluation/run`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}` }
      });
      if (resp.ok) {
        setResults(await resp.json());
      } else {
        const d = await resp.json();
        setError(d.error || 'Evaluation failed');
      }
    } catch (e) {
      setError(e.message);
    }
    setRunning(false);
  };

  const getGrade = (f1) => f1 >= 0.9 ? '✓' : f1 >= 0.7 ? '~' : '✗';

  return (
    <div style={styles.evalPanel}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
        <div style={styles.evalTitle}>Performance Validation</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {results && <span style={{ color: '#888', fontSize: '0.75rem' }}>
            Last run: {results.evaluation_date?.slice(0,10)}
          </span>}
          <button style={styles.runBtn} onClick={runEval} disabled={running}>
            {running ? 'Running...' : '▶ Run Evaluation'}
          </button>
        </div>
      </div>
      <div style={styles.evalSub}>
        Tennessee Eastman Chemical Process Benchmark — Industry standard dataset with 21 fault types
      </div>

      {error && <div style={styles.errorMsg}>{error}</div>}

      {loading ? (
        <div style={{ color: '#888', textAlign: 'center', padding: '3rem' }}>Loading results...</div>
      ) : results ? (
        <>
          {/* Summary stats */}
          <div style={styles.statGrid}>
            <div style={styles.statBox}>
              <div style={styles.statVal}>21/21</div>
              <div style={styles.statLbl}>Detection Rate</div>
            </div>
            <div style={styles.statBox}>
              <div style={{...styles.statVal, color: '#22c55e'}}>{(results.avg_f1 * 100).toFixed(1)}%</div>
              <div style={styles.statLbl}>Avg F1 Score</div>
            </div>
            <div style={styles.statBox}>
              <div style={styles.statVal}>{(results.avg_precision * 100).toFixed(1)}%</div>
              <div style={styles.statLbl}>Avg Precision</div>
            </div>
            <div style={styles.statBox}>
              <div style={styles.statVal}>{(results.avg_recall * 100).toFixed(1)}%</div>
              <div style={styles.statLbl}>Avg Recall</div>
            </div>
            <div style={styles.statBox}>
              <div style={{...styles.statVal, color: '#f59e0b'}}>{results.avg_detection_delay_minutes?.toFixed(1)} min</div>
              <div style={styles.statLbl}>Avg Detection Delay</div>
            </div>
          </div>

          {/* Context banner */}
          <div style={{ ...styles.card, background: 'rgba(167,139,250,0.08)', border: '1px solid rgba(167,139,250,0.3)', marginBottom: '1.5rem' }}>
            <div style={{ color: '#a78bfa', fontSize: '0.85rem', lineHeight: 1.6 }}>
              <strong>Benchmark context:</strong> Published TEP research typically achieves F1 of 0.75–0.92 using 
              complex ML models. ClearPoint achieves <strong>F1={results.avg_f1?.toFixed(3)}</strong> using 
              statistical ensemble detection with <strong>{results.avg_detection_delay_minutes?.toFixed(1)} minute average detection delay</strong>, 
              plus natural language explanations unavailable in competing approaches.
              &nbsp;<button style={{ background: 'none', border: 'none', color: '#4fc3f7', cursor: 'pointer', fontSize: '0.85rem', padding: 0 }}
                onClick={() => onViewFault(6)}>
                → View live Fault 6 demo in dashboard
              </button>
            </div>
          </div>

          {/* Per-fault table */}
          <div style={styles.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <div style={styles.cardTitle}>Per-Fault Results</div>
              <div style={{ fontSize: '0.75rem', color: '#888' }}>
                <span style={{ color: '#22c55e' }}>✓ Excellent (F1≥0.90)</span>
                {' · '}
                <span style={{ color: '#f59e0b' }}>~ Good (F1≥0.70)</span>
                {' · '}
                <span style={{ color: '#ef5350' }}>✗ Difficult</span>
              </div>
            </div>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Fault</th>
                  <th style={styles.th}>Description</th>
                  <th style={styles.th}>F1</th>
                  <th style={styles.th}>Precision</th>
                  <th style={styles.th}>Recall</th>
                  <th style={styles.th}>Delay</th>
                  <th style={styles.th}>Demo</th>
                </tr>
              </thead>
              <tbody>
                {(results.faults || []).map(f => (
                  <tr key={f.fault_id} style={styles.faultRow(f.f1)}>
                    <td style={styles.td}>
                      <span style={{ color: '#888', marginRight: '0.5rem' }}>{getGrade(f.f1)}</span>
                      F{String(f.fault_id).padStart(2,'0')}
                    </td>
                    <td style={{ ...styles.td, color: '#aaa', maxWidth: '300px' }}>{f.description}</td>
                    <td style={styles.td}><span style={styles.f1Badge(f.f1)}>{f.f1.toFixed(3)}</span></td>
                    <td style={styles.td}>{(f.precision * 100).toFixed(1)}%</td>
                    <td style={styles.td}>{(f.recall * 100).toFixed(1)}%</td>
                    <td style={styles.td}>
                      {f.detection_delay_minutes !== null
                        ? `${f.detection_delay_minutes} min`
                        : <span style={{ color: '#ef5350' }}>Not detected</span>}
                    </td>
                    <td style={styles.td}>
                      <button
                        onClick={() => onViewFault(f.fault_id)}
                        style={{ background: 'rgba(79,195,247,0.1)', border: '1px solid #4fc3f7', color: '#4fc3f7',
                          padding: '0.2rem 0.6rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem' }}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
}

// ── Alert Preferences ────────────────────────────────────────────────────────
function AlertPreferences({ keycloak, isAdmin }) {
  const [prefs, setPrefs] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/alerts/preferences`, {
      headers: { Authorization: `Bearer ${keycloak.token}` }
    }).then(r => r.json()).then(d => setPrefs(d.preferences || []));
  }, [keycloak]);

  const save = async (pref) => {
    setSaving(true);
    setMsg(null);
    try {
      const resp = await fetch(`${API_URL}/alerts/preferences`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(pref)
      });
      if (resp.ok) {
        setMsg({ type: 'success', text: '✓ Alert preferences saved' });
      } else {
        setMsg({ type: 'error', text: 'Failed to save' });
      }
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
    setSaving(false);
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div style={styles.cardTitle}>🔔 Alert Preferences</div>
      </div>
      {msg && <div style={msg.type === 'success' ? styles.successMsg : styles.errorMsg}>{msg.text}</div>}
      <table style={styles.table}>
        <thead><tr>
          <th style={styles.th}>Customer</th>
          <th style={styles.th}>Min Severity</th>
          <th style={styles.th}>Cooldown</th>
          <th style={styles.th}>Enabled</th>
          <th style={styles.th}></th>
        </tr></thead>
        <tbody>
          {prefs.map(p => (
            <tr key={p.customer_id}>
              <td style={styles.td}><code style={{color:'#4fc3f7'}}>{p.customer_id}</code></td>
              <td style={styles.td}>
                <select style={{...styles.select, width:'auto'}}
                  defaultValue={p.min_severity}
                  onChange={e => p.min_severity = e.target.value}>
                  <option value="warning">Warning+</option>
                  <option value="alarm">Alarm+</option>
                  <option value="critical">Critical only</option>
                </select>
              </td>
              <td style={styles.td}>
                <select style={{...styles.select, width:'auto'}}
                  defaultValue={p.cooldown_minutes}
                  onChange={e => p.cooldown_minutes = parseInt(e.target.value)}>
                  <option value="15">15 min</option>
                  <option value="30">30 min</option>
                  <option value="60">1 hour</option>
                  <option value="120">2 hours</option>
                  <option value="480">8 hours</option>
                </select>
              </td>
              <td style={styles.td}>
                <input type="checkbox" defaultChecked={p.enabled}
                  onChange={e => p.enabled = e.target.checked} />
              </td>
              <td style={styles.td}>
                <button style={styles.addBtn} onClick={() => save(p)} disabled={saving}>
                  Save
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

// ── Document Manager ─────────────────────────────────────────────────────────
function DocumentManager({ keycloak, profile, isAdmin }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [customerFilter, setCustomerFilter] = useState('');
  const [customers, setCustomers] = useState([]);
  const [category, setCategory] = useState('general');
  const [msg, setMsg] = useState(null);
  const fileInputRef = React.useRef(null);
  const folderInputRef = React.useRef(null);

  const effectiveCustomer = customerFilter || profile?.slug;

  useEffect(() => {
    if (isAdmin) {
      fetch(`${API_URL}/admin/customers`, {
        headers: { Authorization: `Bearer ${keycloak.token}` }
      }).then(r => r.json()).then(d => {
        setCustomers(d.customers || []);
        if (!customerFilter && d.customers?.length) {
          setCustomerFilter(d.customers[0].slug);
        }
      });
    }
  }, [keycloak, isAdmin]);

  const fetchDocs = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${API_URL}/documents?customer_id=${effectiveCustomer}`,
        { headers: { Authorization: `Bearer ${keycloak.token}` } }
      );
      const data = await resp.json();
      setDocs(data.documents || []);
    } catch(e) { console.error(e); }
    setLoading(false);
  }, [keycloak, effectiveCustomer]);

  useEffect(() => { if (effectiveCustomer) fetchDocs(); }, [fetchDocs, effectiveCustomer]);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    setMsg(null);
    const results = [];
    for (const file of files) {
      const form = new FormData();
      form.append('file', file);
      form.append('customer_id', effectiveCustomer);
      form.append('category', category);
      try {
        const resp = await fetch(`${API_URL}/documents/upload`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${keycloak.token}` },
          body: form
        });
        const data = await resp.json();
        if (resp.ok) {
          results.push(`✓ ${file.name} (${data.chunks || 0} chunks)`);
        } else {
          results.push(`✗ ${file.name}: ${data.error || 'failed'}`);
        }
      } catch(err) {
        results.push(`✗ ${file.name}: ${err.message}`);
      }
    }
    const successCount = results.filter(r => r.startsWith('✓')).length;
    setMsg({
      type: successCount === files.length ? 'success' : 'error',
      text: files.length === 1 ? results[0] : `Uploaded ${successCount}/${files.length} files: ${results.join(' | ')}`
    });
    fetchDocs();
    setUploading(false);
    e.target.value = '';
  };

  const handleDelete = async (source) => {
    if (!window.confirm(`Remove "${source}" from the AI Assistant?`)) return;
    setMsg(null);
    try {
      const resp = await fetch(`${API_URL}/documents/delete`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: effectiveCustomer, source })
      });
      const data = await resp.json();
      if (resp.ok) {
        setMsg({ type: 'success', text: `✓ Removed — ${data.chunks_removed} chunks deleted` });
        fetchDocs();
      } else {
        setMsg({ type: 'error', text: data.error || 'Delete failed' });
      }
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  return (
    <div style={styles.adminPanel}>
      <div style={styles.adminTitle}>Document Manager</div>
      <div style={styles.adminSub}>Upload maintenance documents for the AI Operations Assistant</div>

      {isAdmin && customers.length > 0 && (
        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <label style={styles.label}>Customer:</label>
          <select style={{...styles.select, width: 'auto', minWidth: '200px'}}
            value={customerFilter}
            onChange={e => setCustomerFilter(e.target.value)}>
            {customers.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
        </div>
      )}

      {msg && <div style={msg.type === 'success' ? styles.successMsg : styles.errorMsg}>{msg.text}</div>}

      <div style={styles.card}>
        <div style={styles.cardTitle}>Upload Document</div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div>
            <label style={styles.label}>Category</label>
            <select style={{...styles.select, width: 'auto'}}
              value={category} onChange={e => setCategory(e.target.value)}>
              <option value="general">General</option>
              <option value="procedure">Alarm Procedure</option>
              <option value="maintenance">Maintenance</option>
              <option value="specification">Equipment Spec</option>
              <option value="safety">Safety</option>
              <option value="manual">Manual / Datasheet</option>
            </select>
          </div>
          <div>
            <label style={styles.label}>File (PDF, DOCX, TXT, CSV)</label>
            <input ref={fileInputRef} type="file" multiple
              accept=".pdf,.docx,.doc,.txt,.md,.csv,.xlsx"
              onChange={handleUpload}
              style={{ display: 'none' }} />
            <input ref={folderInputRef} type="file" multiple
              webkitdirectory="" directory=""
              accept=".pdf,.docx,.doc,.txt,.md,.csv,.xlsx"
              onChange={handleUpload}
              style={{ display: 'none' }} />
            <button style={styles.addBtn} disabled={uploading}
              onClick={() => fileInputRef.current?.click()}>
              {uploading ? '⏳ Indexing...' : '📄 Choose Files & Upload'}
            </button>
            <button style={{...styles.addBtn, background: '#888'}} disabled={uploading}
              onClick={() => folderInputRef.current?.click()}>
              📁 Choose Folder &amp; Upload
            </button>
          </div>
        </div>
        <div style={{ fontSize: '0.75rem', color: '#888', marginTop: '0.5rem' }}>
          Supported formats: PDF, Word (.docx), Text (.txt, .md), CSV, Excel (.xlsx)
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.cardTitle}>
          Indexed Documents ({docs.length})
          {effectiveCustomer && <span style={{ color: '#888', fontWeight: 400, fontSize: '0.8rem', marginLeft: '0.5rem' }}>
            for {effectiveCustomer}
          </span>}
        </div>
        {loading ? (
          <div style={{ color: '#888', padding: '1rem' }}>Loading...</div>
        ) : docs.length === 0 ? (
          <div style={{ color: '#888', padding: '1rem' }}>
            No documents indexed yet. Upload maintenance procedures, equipment manuals, or alarm response guides above.
          </div>
        ) : (
          <table style={styles.table}>
            <thead><tr>
              <th style={styles.th}>Document</th>
              <th style={styles.th}>Category</th>
              <th style={styles.th}>Chunks</th>
              <th style={styles.th}></th>
            </tr></thead>
            <tbody>
              {docs.map(doc => (
                <tr key={doc.source}>
                  <td style={styles.td}>
                    <span style={{ color: '#e0e0e0', fontSize: '0.9rem' }}>
                      {doc.source.split('/').pop()}
                    </span>
                  </td>
                  <td style={styles.td}>
                    <span style={{ color: '#888', fontSize: '0.8rem' }}>{doc.category}</span>
                  </td>
                  <td style={styles.td}>
                    <span style={{ color: '#4fc3f7', fontSize: '0.85rem' }}>{doc.chunks}</span>
                  </td>
                  <td style={styles.td}>
                    <button style={styles.deleteBtn} onClick={() => handleDelete(doc.source)}>
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// ── Signal Metadata ──────────────────────────────────────────────────────────
function SignalMetadata({ keycloak, profile, isAdmin }) {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [msg, setMsg] = useState(null);
  const [customerFilter, setCustomerFilter] = useState('');

  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (isAdmin) {
      fetch(`${API_URL}/admin/customers`, {
        headers: { Authorization: `Bearer ${keycloak.token}` }
      }).then(r => r.json()).then(d => {
        setCustomers(d.customers || []);
        if (!customerFilter && d.customers?.length) {
          setCustomerFilter(d.customers[0].slug);
        }
      });
    }
  }, [keycloak, isAdmin]);

  const fetchSignals = useCallback(async (custId) => {
    setLoading(true);
    const params = custId ? `?customer_id=${custId}` : '';
    try {
      const resp = await fetch(`${API_URL}/signals/metadata${params}`, {
        headers: { Authorization: `Bearer ${keycloak.token}` }
      });
      const data = await resp.json();
      setSignals(data.signals || []);
    } catch(e) { console.error(e); }
    setLoading(false);
  }, [keycloak]);

  useEffect(() => {
    if (customerFilter || !isAdmin) {
      fetchSignals(customerFilter);
    }
  }, [fetchSignals, customerFilter, isAdmin]);

  const startEdit = (signal) => {
    setEditing(signal.signal);
    setEditForm({
      display_name: signal.display_name || signal.signal,
      unit: signal.unit || '',
      description: signal.description || '',
      normal_min: signal.normal_min || '',
      normal_max: signal.normal_max || '',
    });
  };

  const saveEdit = async (signal) => {
    setMsg(null);
    try {
      const resp = await fetch(`${API_URL}/signals/metadata`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_id: customerFilter || profile?.slug,
          signal_name: signal,
          ...editForm,
          normal_min: editForm.normal_min !== '' ? parseFloat(editForm.normal_min) : null,
          normal_max: editForm.normal_max !== '' ? parseFloat(editForm.normal_max) : null,
        })
      });
      if (resp.ok) {
        setMsg({ type: 'success', text: `✓ ${signal} updated` });
        setEditing(null);
        fetchSignals(customerFilter);
      } else {
        const d = await resp.json();
        setMsg({ type: 'error', text: d.error });
      }
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  return (
    <div style={styles.adminPanel}>
      <div style={styles.adminTitle}>Signal Metadata</div>
      <div style={styles.adminSub}>Configure display names, units, and normal ranges for plant signals</div>

      {msg && <div style={msg.type === 'success' ? styles.successMsg : styles.errorMsg}>{msg.text}</div>}

      {isAdmin && customers.length > 0 && (
        <div style={{marginBottom: '1rem', display:'flex', alignItems:'center', gap:'1rem'}}>
          <label style={styles.label}>Customer:</label>
          <select style={{...styles.select, width:'auto', minWidth:'200px'}}
            value={customerFilter}
            onChange={e => { setCustomerFilter(e.target.value); setEditing(null); }}>
            {customers.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
        </div>
      )}

      {loading ? (
        <div style={{ color: '#888', textAlign: 'center', padding: '3rem' }}>Loading signals...</div>
      ) : (
        <div style={styles.card}>
          <div style={styles.cardTitle}>Signals ({signals.length}){customerFilter && <span style={{color:'#888', fontWeight:400, fontSize:'0.8rem', marginLeft:'0.5rem'}}>for {customerFilter}</span>}</div>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Tag Name</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Display Name</th>
                <th style={styles.th}>Unit</th>
                <th style={styles.th}>Normal Range</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}></th>
              </tr>
            </thead>
            <tbody>
              {signals.map(s => (
                <tr key={s.signal}>
                  <td style={styles.td}><code style={{color:'#4fc3f7'}}>{s.signal}</code></td>
                  <td style={styles.td}><span style={{color:'#888', fontSize:'0.8rem'}}>{s.signal_category}</span></td>
                  {editing === s.signal ? (
                    <>
                      <td style={styles.td}>
                        <input style={{...styles.input, width:'140px'}}
                          value={editForm.display_name}
                          onChange={e => setEditForm({...editForm, display_name: e.target.value})} />
                      </td>
                      <td style={styles.td}>
                        <input style={{...styles.input, width:'80px'}}
                          value={editForm.unit}
                          onChange={e => setEditForm({...editForm, unit: e.target.value})} />
                      </td>
                      <td style={styles.td}>
                        <div style={{display:'flex', gap:'4px', alignItems:'center'}}>
                          <input style={{...styles.input, width:'70px'}}
                            placeholder="min" value={editForm.normal_min}
                            onChange={e => setEditForm({...editForm, normal_min: e.target.value})} />
                          <span style={{color:'#888'}}>–</span>
                          <input style={{...styles.input, width:'70px'}}
                            placeholder="max" value={editForm.normal_max}
                            onChange={e => setEditForm({...editForm, normal_max: e.target.value})} />
                        </div>
                      </td>
                      <td style={styles.td}>
                        <input style={{...styles.input, width:'180px'}}
                          value={editForm.description}
                          onChange={e => setEditForm({...editForm, description: e.target.value})} />
                      </td>
                      <td style={styles.td}>
                        <button style={{...styles.addBtn, marginRight:'4px'}} onClick={() => saveEdit(s.signal)}>Save</button>
                        <button style={styles.deleteBtn} onClick={() => setEditing(null)}>Cancel</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td style={styles.td}>
                        {s.display_name !== s.signal
                          ? <span style={{color:'#e0e0e0'}}>{s.display_name}</span>
                          : <span style={{color:'#555', fontStyle:'italic'}}>not set</span>}
                      </td>
                      <td style={styles.td}><span style={{color:'#888'}}>{s.unit || '—'}</span></td>
                      <td style={styles.td}>
                        {s.normal_min != null && s.normal_max != null
                          ? <span style={{color:'#22c55e', fontSize:'0.8rem'}}>{s.normal_min} – {s.normal_max}</span>
                          : <span style={{color:'#555'}}>—</span>}
                      </td>
                      <td style={styles.td}><span style={{color:'#888', fontSize:'0.8rem'}}>{s.description || '—'}</span></td>
                      <td style={styles.td}>
                        <button style={styles.navBtn} onClick={() => startEdit(s)}>Edit</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {signals.length === 0 && (
                <tr><td colSpan={7} style={{...styles.td, textAlign:'center', color:'#888'}}>
                  No signals found. Signals appear here once the detector has processed data.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ── Add Customer Form ────────────────────────────────────────────────────────
function AddCustomerForm({ keycloak, onCreated }) {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: '', slug: '', contact_email: '' });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const autoSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

  const handleNameChange = (e) => {
    const name = e.target.value;
    setForm(f => ({ ...f, name, slug: autoSlug(name) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const resp = await fetch(`${API_URL}/admin/customers`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await resp.json();
      setResult(data);
      if (resp.status === 201 || resp.status === 207) {
        setForm({ name: '', slug: '', contact_email: '' });
        if (resp.status === 201) setShow(false);
        onCreated();
      }
    } catch(e) { setResult({ error: e.message }); }
    setLoading(false);
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: show ? '1rem' : 0 }}>
        <div style={styles.cardTitle}>Add New Customer</div>
        <button style={styles.addBtn} onClick={() => { setShow(!show); setResult(null); }}>
          {show ? 'Cancel' : '+ New Customer'}
        </button>
      </div>

      {result && (
        <div style={{ marginBottom: '1rem' }}>
          {result.error && <div style={styles.errorMsg}>✗ {result.error}</div>}
          {result.results && Object.entries(result.results).map(([k, v]) => (
            <div key={k} style={{ ...styles.successMsg, marginBottom: '4px' }}>{v}</div>
          ))}
          {result.errors && result.errors.map((e, i) => (
            <div key={i} style={{ ...styles.errorMsg, marginBottom: '4px' }}>⚠ {e}</div>
          ))}
        </div>
      )}

      {show && (
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formRow}>
            <div>
              <label style={styles.label}>Company Name *</label>
              <input style={styles.input} value={form.name}
                onChange={handleNameChange}
                placeholder="Acme Refining Co." required />
            </div>
            <div>
              <label style={styles.label}>Slug * (auto-generated)</label>
              <input style={styles.input} value={form.slug}
                onChange={e => setForm(f => ({...f, slug: e.target.value}))}
                placeholder="acme_refining" required />
              <div style={{ fontSize: '0.7rem', color: '#888', marginTop: '4px' }}>
                Lowercase letters, numbers, underscores only
              </div>
            </div>
          </div>
          <div style={styles.formRow}>
            <div>
              <label style={styles.label}>Contact Email (optional)</label>
              <input style={styles.input} type="email" value={form.contact_email}
                onChange={e => setForm(f => ({...f, contact_email: e.target.value}))}
                placeholder="operator@company.com" />
              <div style={{ fontSize: '0.7rem', color: '#888', marginTop: '4px' }}>
                Will receive an invitation email to set up their account
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button type="submit" style={styles.addBtn} disabled={loading}>
                {loading ? 'Creating...' : 'Create Customer'}
              </button>
            </div>
          </div>
          {loading && (
            <div style={{ color: '#888', fontSize: '0.85rem' }}>
              ⏳ Setting up customer infrastructure (Keycloak, Grafana, InfluxDB)...
            </div>
          )}
        </form>
      )}
    </>
  );
}

// ── Process Flow ──────────────────────────────────────────────────────────────
function ProcessFlow({ keycloak, onSignalClick }) {
  const [flowData, setFlowData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const svgRef = React.useRef(null);

  const SEV_COLOR = { normal: '#22c55e', warning: '#eab308', alarm: '#f97316', critical: '#ef4444' };
  const SEV_GLOW  = { normal: 'none', warning: 'drop-shadow(0 0 6px #eab308)', alarm: 'drop-shadow(0 0 8px #f97316)', critical: 'drop-shadow(0 0 10px #ef4444)' };

  const NODE_SHAPES = {
    tank:      (x, y) => `M${x},${y-30} L${x+38},${y-30} L${x+38},${y+30} L${x},${y+30} Z`,
    vessel:    (x, y) => `M${x-5},${y-35} Q${x+40},${y-35} ${x+45},${y} Q${x+40},${y+35} ${x-5},${y+35} L${x-5},${y-35}Z`,
    pump:      (x, y) => null,
    exchanger: (x, y) => `M${x},${y-25} L${x+50},${y-25} L${x+50},${y+25} L${x},${y+25} Z`,
    output:    (x, y) => `M${x},${y-20} L${x+36},${y-20} L${x+36},${y+20} L${x},${y+20} Z`,
  };

  useEffect(() => {
    fetch(`${API_URL}/process-flow`, {
      headers: { Authorization: `Bearer ${keycloak.token}` }
    })
    .then(r => r.json())
    .then(data => { setFlowData(data); setLoading(false); })
    .catch(e => { setError(e.message); setLoading(false); });
  }, [keycloak]);

  // Refresh every 30s to pick up new anomaly data
  useEffect(() => {
    const t = setInterval(() => {
      fetch(`${API_URL}/process-flow`, { headers: { Authorization: `Bearer ${keycloak.token}` } })
        .then(r => r.json()).then(setFlowData).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, [keycloak]);

  if (loading) return <div style={{ color: '#888', textAlign: 'center', padding: '4rem' }}>Loading process flow...</div>;
  if (error) return <div style={{ color: '#ef5350', textAlign: 'center', padding: '4rem' }}>Error: {error}</div>;
  if (!flowData?.nodes?.length) return <div style={{ color: '#888', textAlign: 'center', padding: '4rem' }}>No process flow configured for this customer.</div>;

  const nodeMap = Object.fromEntries(flowData.nodes.map(n => [n.node_key, n]));

  // Auto-layout: spread nodes horizontally
  const W = 900, H = 420, PAD = 80;
  const mainEdges = flowData.edges.filter(e => {
    const from = nodeMap[e.from_node_key];
    const to = nodeMap[e.to_node_key];
    return from && to;
  });

  // Use stored positions scaled to SVG
  const scaleX = (px) => PAD + (px / 680) * (W - PAD * 2);
  const scaleY = (py) => 60 + (py / 420) * (H - 120);

  const nodePos = {};
  flowData.nodes.forEach(n => {
    nodePos[n.node_key] = { x: scaleX(n.pos_x + 50), y: scaleY(n.pos_y + 50) };
  });

  return (
    <div style={{ padding: '1rem', background: '#0f1117', minHeight: 'calc(100vh - 56px)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', paddingLeft: '0.5rem' }}>
        <div>
          <div style={{ color: '#4fc3f7', fontWeight: 700, fontSize: '1.1rem' }}>Process Flow</div>
          <div style={{ color: '#888', fontSize: '0.8rem' }}>Click any node to view signal detail. Updates every 30 seconds.</div>
        </div>
        <div style={{ display: 'flex', gap: '1rem', fontSize: '0.78rem', color: '#888' }}>
          {Object.entries(SEV_COLOR).map(([s,c]) => (
            <span key={s} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: c, display: 'inline-block' }}/>
              {s}
            </span>
          ))}
        </div>
      </div>

      <div style={{ background: '#12141e', borderRadius: '10px', border: '1px solid #2a2d3e', overflow: 'hidden' }}>
        <svg ref={svgRef} viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
          <defs>
            <marker id="pf-arrow" viewBox="0 0 10 10" refX="8" refY="5"
              markerWidth="6" markerHeight="6" orient="auto">
              <path d="M2 1L8 5L2 9" fill="none" stroke="#4a5568" strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round"/>
            </marker>
            <style>{`
              @keyframes flowdash { to { stroke-dashoffset: -24; } }
              .pf-flow { stroke-dasharray: 6 10; animation: flowdash 1.4s linear infinite; }
              .pf-flow-fast { stroke-dasharray: 6 10; animation: flowdash 0.7s linear infinite; }
              .pf-node { cursor: pointer; transition: filter 0.15s; }
              .pf-node:hover rect, .pf-node:hover path, .pf-node:hover circle { stroke-width: 2; opacity: 0.92; }
              @keyframes pulse { 0%,100%{opacity:0.5;r:28} 50%{opacity:0.12;r:42} }
              .pf-pulse { animation: pulse 1.6s ease-in-out infinite; }
            `}</style>
          </defs>

          {/* Edges / pipes */}
          {flowData.edges.map((edge, i) => {
            const from = nodePos[edge.from_node_key];
            const to = nodePos[edge.to_node_key];
            if (!from || !to) return null;
            const sev = edge.signal?.severity || 'normal';
            const color = sev !== 'normal' ? SEV_COLOR[sev] : '#2d6a9f';
            const isFast = sev === 'critical' || sev === 'alarm';
            return (
              <g key={i}>
                <line x1={from.x} y1={from.y} x2={to.x} y2={to.y}
                  stroke="#1e2433" strokeWidth={6}/>
                <line x1={from.x} y1={from.y} x2={to.x} y2={to.y}
                  stroke={color} strokeWidth={3}
                  className={isFast ? 'pf-flow-fast' : 'pf-flow'}
                  markerEnd="url(#pf-arrow)"/>
                {edge.signal?.value != null && (
                  <text
                    x={(from.x + to.x) / 2}
                    y={(from.y + to.y) / 2 - 8}
                    textAnchor="middle"
                    fill="#6b7280" fontSize="10"
                    style={{ pointerEvents: 'none' }}>
                    {edge.signal.display_name || edge.signal.signal_name}
                  </text>
                )}
              </g>
            );
          })}

          {/* Nodes */}
          {flowData.nodes.map(node => {
            const pos = nodePos[node.node_key];
            if (!pos) return null;
            const sev = node.signal?.severity || 'normal';
            const color = SEV_COLOR[sev];
            const isAnomalous = sev !== 'normal';
            const isPump = node.node_type === 'pump';

            return (
              <g key={node.node_key} className="pf-node"
                onClick={() => onSignalClick(node.signal?.signal_name || node.signal_name)}
                style={{ filter: SEV_GLOW[sev] }}>

                {isAnomalous && (
                  <circle cx={pos.x} cy={pos.y} fill="none"
                    stroke={color} strokeWidth={2} opacity={0.5}
                    className="pf-pulse" r={28}/>
                )}

                {isPump ? (
                  <circle cx={pos.x} cy={pos.y} r={26}
                    fill="#1a1d2e" stroke={color} strokeWidth={1.5}/>
                ) : (
                  <rect x={pos.x - 36} y={pos.y - 30}
                    width={72} height={60} rx={6}
                    fill="#1a1d2e" stroke={color} strokeWidth={1.5}/>
                )}

                <text x={pos.x} y={pos.y - 8} textAnchor="middle"
                  fill="#e0e0e0" fontSize="11" fontWeight="500"
                  style={{ pointerEvents: 'none' }}>
                  {node.label}
                </text>

                {node.signal?.value != null && (
                  <text x={pos.x} y={pos.y + 8} textAnchor="middle"
                    fill={color} fontSize="11" fontWeight="600"
                    style={{ pointerEvents: 'none' }}>
                    {node.signal.value.toFixed(1)} {node.signal.unit}
                  </text>
                )}

                <text x={pos.x} y={pos.y + 22} textAnchor="middle"
                  fill="#9aa0ad" fontSize="9"
                  style={{ pointerEvents: 'none' }}>
                  {node.signal?.display_name && node.signal.display_name !== node.signal.signal_name
                    ? node.signal.display_name
                    : node.signal?.signal_name || node.signal_name}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}

// ── Admin Panel ───────────────────────────────────────────────────────────────
function AdminPanel({ keycloak, profile }) {
  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({ first_name: '', last_name: '', email: '', customer_slug: '', role: 'operator', role: 'operator' });
  const [msg, setMsg] = useState(null);
  const [adminTab, setAdminTab] = useState('users');
  const roles = keycloak.tokenParsed?.roles || [];
  const isAdmin = roles.includes('admin');

  const fetchData = useCallback(async () => {
    const token = keycloak.token;
    setLoading(true);
    try {
      const [usersResp, customersResp] = await Promise.all([
        fetch(`${API_URL}/admin/users`, { headers: { Authorization: `Bearer ${token}` } }),
        isAdmin ? fetch(`${API_URL}/admin/customers`, { headers: { Authorization: `Bearer ${token}` } }) : Promise.resolve(null)
      ]);
      const usersData = await usersResp.json();
      setUsers(usersData.users || []);
      if (customersResp) {
        const custData = await customersResp.json();
        setCustomers(custData.customers || []);
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [keycloak, isAdmin]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleAdd = async (e) => {
    e.preventDefault();
    setMsg(null);
    try {
      const resp = await fetch(`${API_URL}/admin/users`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await resp.json();
      if (resp.ok) {
        setMsg({ type: 'success', text: `✓ ${data.message}` });
        setShowAddForm(false);
        setFormData({ first_name: '', last_name: '', email: '', customer_slug: '', role: 'operator', role: 'operator' });
        fetchData();
      } else {
        setMsg({ type: 'error', text: data.error });
      }
    } catch (e) { setMsg({ type: 'error', text: e.message }); }
  };

  const handleDelete = async (email) => {
    if (!window.confirm(`Remove user ${email}?`)) return;
    try {
      const resp = await fetch(`${API_URL}/admin/users/${encodeURIComponent(email)}`, {
        method: 'DELETE', headers: { Authorization: `Bearer ${keycloak.token}` }
      });
      const data = await resp.json();
      if (resp.ok) { setMsg({ type: 'success', text: `✓ ${data.message}` }); fetchData(); }
      else setMsg({ type: 'error', text: data.error });
    } catch (e) { setMsg({ type: 'error', text: e.message }); }
  };

  const formCustomers = isAdmin ? customers : (profile ? [{ slug: profile.slug, name: profile.name }] : []);

  return (
    <div style={styles.adminPanel}>
      <div style={styles.adminTitle}>Admin Panel</div>
      <div style={styles.adminSub}>Manage users and customers for ClearPoint Analytics</div>
      <div style={{display:'flex', gap:'0.5rem', marginBottom:'1.5rem'}}>
        {['users','signals','documents','customers','flow'].map(tab => (
          (!isAdmin && tab === 'customers') ? null :
          <button key={tab} style={{...styles.navBtn, ...(adminTab===tab ? styles.navBtnActive : {})}}
            onClick={() => setAdminTab(tab)}>
            {tab === 'users' ? '👥 Users' : tab === 'signals' ? '📡 Signals' : tab === 'documents' ? '📄 Documents' : tab === 'flow' ? '🔀 Flow' : '🏭 Customers'}
          </button>
        ))}
      </div>
      {msg && <div style={msg.type === 'success' ? styles.successMsg : styles.errorMsg}>{msg.text}</div>}
      {adminTab === 'flow' ? <FlowEditor keycloak={keycloak} isAdmin={isAdmin} customers={customers} /> : adminTab === 'signals' ? <SignalMetadata keycloak={keycloak} profile={profile} isAdmin={isAdmin} /> : adminTab === 'documents' ? <DocumentManager keycloak={keycloak} profile={profile} isAdmin={isAdmin} /> : adminTab === 'users' ? <>
      <div style={styles.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={styles.cardTitle}>Users {loading ? '' : `(${users.length})`}</div>
          <button style={styles.addBtn} onClick={() => setShowAddForm(!showAddForm)}>
            {showAddForm ? 'Cancel' : '+ Add User'}
          </button>
        </div>
        {showAddForm && (
          <form onSubmit={handleAdd} style={{ ...styles.form, marginBottom: '1.5rem', padding: '1rem', background: '#0f1117', borderRadius: '6px' }}>
            <div style={styles.formRow}>
              <div><label style={styles.label}>First Name *</label>
                <input style={styles.input} value={formData.first_name} onChange={e => setFormData({...formData, first_name: e.target.value})} required /></div>
              <div><label style={styles.label}>Last Name</label>
                <input style={styles.input} value={formData.last_name} onChange={e => setFormData({...formData, last_name: e.target.value})} /></div>
            </div>
            <div style={styles.formRow}>
              <div><label style={styles.label}>Email *</label>
                <input style={styles.input} type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required /></div>
              <div><label style={styles.label}>Customer *</label>
                <select style={styles.select} value={formData.customer_slug} onChange={e => setFormData({...formData, customer_slug: e.target.value})} required>
                  <option value="">Select customer...</option>
                  {formCustomers.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
                </select></div>
            </div>
            <div style={styles.formRow}>
              <div>
                <label style={styles.label}>Role *</label>
                <select style={styles.select} value={formData.role}
                  onChange={e => setFormData({...formData, role: e.target.value})}>
                  {isAdmin && <option value="plant-manager">Plant Manager</option>}
                  <option value="operator">Operator</option>
                </select>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <span style={{ color: '#888', fontSize: '0.75rem' }}>
                  {formData.role === 'plant-manager' ? '👔 Can manage operators' : '🔧 Can view dashboards'}
                </span>
              </div>
            </div>
            <div><button type="submit" style={styles.addBtn}>Send Invitation</button>
              <span style={{ color: '#888', fontSize: '0.75rem', marginLeft: '1rem' }}>User will receive an email to set their password</span></div>
          </form>
        )}
        {loading ? <div style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>Loading...</div> : (
          <table style={styles.table}>
            <thead><tr>
              <th style={styles.th}>Email</th><th style={styles.th}>Customer</th>
              <th style={styles.th}>Added</th><th style={styles.th}></th>
            </tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td style={styles.td}>{u.email}</td>
                  <td style={styles.td}>{u.customer_name}</td>
                  <td style={styles.td}>
                    <span style={{ fontSize: '0.75rem', padding: '0.2rem 0.5rem', borderRadius: '4px',
                      background: u.role === 'admin' ? 'rgba(239,83,80,0.15)' : u.role === 'plant-manager' ? 'rgba(245,158,11,0.15)' : 'rgba(79,195,247,0.15)',
                      color: u.role === 'admin' ? '#ef5350' : u.role === 'plant-manager' ? '#f59e0b' : '#4fc3f7' }}>
                      {u.role || 'operator'}
                    </span>
                  </td>
                  <td style={styles.td}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '—'}</td>
                  <td style={styles.td}><button style={styles.deleteBtn} onClick={() => handleDelete(u.email)}>Remove</button></td>
                </tr>
              ))}
              {users.length === 0 && <tr><td colSpan={4} style={{...styles.td, textAlign:'center', color:'#888'}}>No users found</td></tr>}
            </tbody>
          </table>
        )}
      </div>
      <div style={styles.card}>
        <AlertPreferences keycloak={keycloak} isAdmin={isAdmin} />
      </div>
      </> : null}

      {adminTab === 'customers' && isAdmin && (
        <div style={styles.card}>
          <AddCustomerForm keycloak={keycloak} onCreated={fetchData} />
        </div>
      )}
      {adminTab === 'customers' && isAdmin && (
        <div style={styles.card}>
          <div style={styles.cardTitle}>Customers ({customers.length})</div>
          <table style={styles.table}>
            <thead><tr>
              <th style={styles.th}>Name</th><th style={styles.th}>Slug</th>
              <th style={styles.th}>Users</th><th style={styles.th}>Keycloak Group</th>
            </tr></thead>
            <tbody>
              {customers.map(c => (
                <tr key={c.id}>
                  <td style={styles.td}>{c.name}</td>
                  <td style={styles.td}><code style={{ color: '#4fc3f7' }}>{c.slug}</code></td>
                  <td style={styles.td}>{c.user_count}</td>
                  <td style={styles.td}>{c.keycloak_group}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
// ── Mobile breakpoint ────────────────────────────────────────────────────────
const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(true);
  React.useEffect(() => {
    const check = () => {
      setIsMobile(window.innerWidth <= 1200);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);
  return isMobile;
};

export default function App({ keycloak }) {
  const [profile, setProfile] = useState(null);
  const [dashboards, setDashboards] = useState(null);
  const [activeView, setActiveView] = useState('overview');
  const [timeRange, setTimeRange] = useState(DEFAULT_TIME);
  const [selectedSignal, setSelectedSignal] = useState('');
  const [signalList, setSignalList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const iframeRef = useRef(null);

  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [toasts, setToasts] = useState([]);
  const roles = keycloak.tokenParsed?.roles || [];
  const isAdminOrManager = roles.includes('admin') || roles.includes('plant-manager');

  useEffect(() => {
    if (!profile?.slug) return;
    const socket = io(window.location.origin, { path: '/socket.io', transports: ['websocket', 'polling'] });
    socket.on('connect', () => {
      socket.emit('join_customer', { customer_id: profile.slug });
    });
    socket.on('new_anomaly', (data) => {
      const id = `${data.signal_name}-${Date.now()}`;
      setToasts(prev => [...prev, { id, ...data }].slice(-5));
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 10000);
    });
    return () => socket.disconnect();
  }, [profile]);

  const dismissToast = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  useEffect(() => {
    const token = keycloak.token;
    Promise.all([
      fetch(`${API_URL}/customer/profile`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API_URL}/dashboards`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API_URL}/signals/metadata`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).catch(() => ({ signals: [] })),
    ])
      .then(([prof, dash, sigs]) => {
        setProfile(prof);
        setDashboards(dash);
        setSignalList((sigs.signals || []).map(s => s.signal).sort());
        setLoading(false);
      })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [keycloak]);

  const handleIframeLoad = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    injectStyles(iframe);
    setTimeout(() => injectStyles(iframe), 500);
    setTimeout(() => injectStyles(iframe), 1500);
    setTimeout(() => injectStyles(iframe), 3000);
  }, []);

  const handleLogout = useCallback(() => {
    keycloak.logout({ redirectUri: window.location.origin });
  }, [keycloak]);

  const [replayStatus, setReplayStatus] = useState(null);

  const [tepDashboards, setTepDashboards] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/dashboards/tep`, { headers: { Authorization: `Bearer ${keycloak.token}` } })
      .then(r => r.json()).then(d => { if (!d.error) setTepDashboards(d); })
      .catch(() => {});
  }, [keycloak]);

  const handleViewFault = useCallback(async (faultId) => {
    setReplayStatus({ faultId, status: 'starting', message: `Starting Fault ${faultId} replay...` });
    fetch(`${API_URL}/evaluation/replay`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ fault_id: faultId })
    }).then(r => r.json()).then(data => {
      setReplayStatus({ faultId, status: 'running', message: data.message });
    }).catch(e => {
      setReplayStatus({ faultId, status: 'error', message: e.message });
    });
    setTimeout(() => {
      setActiveView('tep_overview');
      setTimeout(() => setReplayStatus(null), 30000);
    }, 2000);
  }, [keycloak]);

  const getDashboardUrl = () => {
    const applyTimeRange = (baseUrl) => {
      const url = new URL(baseUrl, 'https://placeholder.local');
      url.searchParams.set('from', timeRange.from);
      url.searchParams.set('to', timeRange.to);
      return baseUrl.split('?')[0] + '?' + url.searchParams.toString();
    };
    if (activeView === 'tep_overview') {
      if (!tepDashboards?.overview) return null;
      return applyTimeRange(tepDashboards.overview.url);
    }
    if (!dashboards || !dashboards.overview) return null;
    const base = activeView === 'signal_detail'
      ? (dashboards.signal_detail ? dashboards.signal_detail.url : dashboards.overview.url)
      : dashboards.overview.url;
    let url = applyTimeRange(base);
    if (activeView === 'signal_detail' && selectedSignal) {
      url += `&var-signal=${encodeURIComponent(selectedSignal)}`;
    }
    return url;
  };

  if (loading) return (
    <div style={styles.app}>
      <nav style={styles.nav}><div style={styles.navLeft}><span style={styles.logo}>ClearPoint Analytics</span></div></nav>
      <div style={styles.loading}>Loading your dashboard...</div>
    </div>
  );

  if (error && !isAdminOrManager) return (
    <div style={styles.app}>
      <nav style={styles.nav}><div style={styles.navLeft}><span style={styles.logo}>ClearPoint Analytics</span></div></nav>
      <div style={styles.error}>Error: {error}</div>
    </div>
  );

  const severityColor = (sev) => sev === 'critical' ? '#ef4444' : sev === 'alarm' ? '#f97316' : '#eab308';
  const severityEmoji = (sev) => sev === 'critical' ? '🔴' : sev === 'alarm' ? '🟠' : '🟡';

  return (
    <div style={styles.app}>
      <div style={styles.toastContainer}>
        {toasts.map(t => (
          <div key={t.id} style={{...styles.toast, borderLeft: `3px solid ${severityColor(t.severity)}`}}
            onClick={() => { setActiveView('signal_detail'); setSelectedSignal(t.signal_name); dismissToast(t.id); }}>
            <div style={styles.toastTitle}>{severityEmoji(t.severity)} {t.severity?.toUpperCase()} — {t.display_name || t.signal_name}</div>
            <div style={styles.toastBody}>Value: {Number(t.value).toFixed(2)} &nbsp;|&nbsp; Score: {Number(t.score).toFixed(2)}</div>
          </div>
        ))}
      </div>
      <nav style={styles.nav}>
        <div style={styles.navLeft}>
          <span style={styles.logo}>ClearPoint Analytics</span>
          {profile && <span style={styles.customerName}>{profile.name}</span>}
        </div>
        <div style={styles.navRight}>
          {isMobile ? (
            <button className="mobile-hamburger" style={styles.hamburger} onClick={() => setMenuOpen(o => !o)}>☰</button>
          ) : (
            <>
              <button style={{...styles.navBtn, ...(activeView==='overview' ? styles.navBtnActive : {})}}
                onClick={() => setActiveView('overview')}>Plant Overview</button>
              <button style={{...styles.navBtn, ...(activeView==='signal_detail' ? styles.navBtnActive : {})}}
                onClick={() => setActiveView('signal_detail')}>Signal Detail</button>
              {activeView === 'signal_detail' && signalList.length > 0 && (
                <select style={styles.timeSelect} value={selectedSignal}
                  onChange={e => setSelectedSignal(e.target.value)}>
                  <option value="">Select signal...</option>
                  {signalList.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              )}
              <div style={styles.divider} />
              <select style={styles.timeSelect} value={timeRange.label}
                onChange={e => setTimeRange(TIME_RANGES.find(t => t.label === e.target.value) || DEFAULT_TIME)}>
                {TIME_RANGES.map(t => <option key={t.label} value={t.label}>{t.label}</option>)}
              </select>
              <div style={styles.divider} />
              <a href="https://chat.clearpoint-analytics.com/ClearPoint_Operators_User_Guide.pdf"
                target="_blank" rel="noopener noreferrer" style={styles.navLinkBtn}>User Guide</a>
              <a href={`https://chat.clearpoint-analytics.com/${profile?.slug || ""}${profile?.slug ? "_reports" : "reports"}.html`}
                target="_blank" rel="noopener noreferrer" style={styles.navLinkBtn}>Generate Report</a>
              <a href={`https://chat.clearpoint-analytics.com/${profile?.slug || ""}.html`}
                target="_blank" rel="noopener noreferrer" style={styles.navLinkBtn}>AI Assistant</a>
              <div style={styles.divider} />
              {(roles.includes('admin') || roles.includes('plant-manager')) && (
                <button
                  style={{...styles.navBtnEval, ...(activeView==='evaluation' ? {background:'#a78bfa', color:'#0f1117'} : {})}}
                  onClick={() => setActiveView('evaluation')}>
                  📊 Benchmark
                </button>
              )}
              <button
                style={{...styles.navBtn, ...(activeView==='process_flow' ? styles.navBtnActive : {})}}
                onClick={() => setActiveView('process_flow')}>
                🏭 Flow
              </button>
              {isAdminOrManager && (
                <button
                  style={{...styles.navBtnAdmin, ...(activeView==='admin' ? {background:'#f59e0b', color:'#0f1117'} : {})}}
                  onClick={() => setActiveView('admin')}>
                  ⚙ Admin
                </button>
              )}
              <div style={styles.divider} />
              <button style={styles.logoutBtn} onClick={handleLogout}>Sign out</button>
            </>
          )}
        </div>
      </nav>
      {isMobile && menuOpen && (
        <div style={styles.mobileMenu} onClick={() => setMenuOpen(false)}>
          <button style={{...styles.mobileBtn, ...(activeView==='overview' ? styles.mobileBtnActive : {})}}
            onClick={() => setActiveView('overview')}>🏭 Plant Overview</button>
          <button style={{...styles.mobileBtn, ...(activeView==='signal_detail' ? styles.mobileBtnActive : {})}}
            onClick={() => setActiveView('signal_detail')}>📈 Signal Detail</button>
          {activeView === 'signal_detail' && signalList.length > 0 && (
            <select style={{...styles.timeSelect, width:'100%', padding:'0.6rem'}} value={selectedSignal}
              onChange={e => setSelectedSignal(e.target.value)}>
              <option value="">Select signal...</option>
              {signalList.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          )}
          <select style={{...styles.timeSelect, width:'100%', padding:'0.6rem'}} value={timeRange.label}
            onChange={e => setTimeRange(TIME_RANGES.find(t => t.label === e.target.value) || DEFAULT_TIME)}>
            {TIME_RANGES.map(t => <option key={t.label} value={t.label}>{t.label}</option>)}
          </select>
          <a href="https://chat.clearpoint-analytics.com/ClearPoint_Operators_User_Guide.pdf"
            target="_blank" rel="noopener noreferrer" style={styles.mobileBtn}>📄 User Guide</a>
          <a href={`https://chat.clearpoint-analytics.com/${profile?.slug || ""}${profile?.slug ? "_reports" : "reports"}.html`}
            target="_blank" rel="noopener noreferrer" style={styles.mobileBtn}>📊 Generate Report</a>
          <a href={`https://chat.clearpoint-analytics.com/${profile?.slug || ""}.html`}
            target="_blank" rel="noopener noreferrer" style={styles.mobileBtn}>🤖 AI Assistant</a>
          {(roles.includes('admin') || roles.includes('plant-manager')) && (
            <>
              <button style={{...styles.mobileBtn, color:'#a78bfa', borderColor:'#a78bfa',
                ...(activeView==='evaluation' ? {background:'#a78bfa', color:'#0f1117'} : {})}}
                onClick={() => setActiveView('evaluation')}>📊 Benchmark</button>
              <button style={{...styles.mobileBtn, ...(activeView==='process_flow' ? styles.mobileBtnActive : {})}} onClick={() => setActiveView('process_flow')}>🏭 Flow</button>
            </>
          )}
          {isAdminOrManager && (
            <button style={{...styles.mobileBtn, color:'#f59e0b', borderColor:'#f59e0b',
              ...(activeView==='admin' ? {background:'#f59e0b', color:'#0f1117'} : {})}}
              onClick={() => setActiveView('admin')}>⚙ Admin</button>
          )}
          <button style={{...styles.mobileBtn, color:'#888'}} onClick={handleLogout}>Sign out</button>
        </div>
      )}
      <main style={{...styles.main, marginTop: isMobile && menuOpen ? '56px' : '56px'}}>
        {activeView === 'admin' ? (
          <AdminPanel keycloak={keycloak} profile={profile} />
        ) : activeView === 'evaluation' ? (
          <>
            {replayStatus && (
              <div style={{
                position: 'fixed', top: '56px', left: 0, right: 0, zIndex: 99,
                background: replayStatus.status === 'error' ? '#ef5350' : '#1a1d27',
                borderBottom: '1px solid #a78bfa',
                padding: '0.6rem 1.5rem', color: '#e0e0e0', fontSize: '0.85rem',
                display: 'flex', alignItems: 'center', gap: '0.75rem'
              }}>
                {replayStatus.status === 'starting' && <span>⏳</span>}
                {replayStatus.status === 'running' && <span style={{color:'#a78bfa'}}>▶</span>}
                {replayStatus.status === 'error' && <span>✗</span>}
                <span>Fault {replayStatus.faultId}: {replayStatus.message || 'Starting replay...'}</span>
                {replayStatus.status === 'running' && (
                  <span style={{color:'#888'}}>— Switching to dashboard in 3s...</span>
                )}
              </div>
            )}
            <EvalPanel keycloak={keycloak} onViewFault={handleViewFault} />
          </>
        ) : activeView === 'process_flow' ? (
          <ProcessFlow keycloak={keycloak} onSignalClick={(sig) => {
            setSelectedSignal(sig);
            setActiveView('signal_detail');
          }} />
        ) : getDashboardUrl() ? (
          <iframe ref={iframeRef} key={getDashboardUrl()} src={getDashboardUrl()}
            style={styles.iframe}
            title={activeView === 'overview' ? 'Plant Overview' : 'Signal Detail'}
            onLoad={handleIframeLoad} allowFullScreen />
        ) : (
          <div style={styles.loading}>No dashboard configured for this account.</div>
        )}
      </main>
    </div>
  );
}

// ── Flow Editor ───────────────────────────────────────────────────────────────
function FlowEditor({ keycloak, isAdmin, customers }) {
  const token = keycloak.token;
  const [customerId, setCustomerId] = useState('');
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [signals, setSignals] = useState([]);
  const [msg, setMsg] = useState(null);
  const [dragging, setDragging] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [showNodeForm, setShowNodeForm] = useState(false);
  const [showEdgeForm, setShowEdgeForm] = useState(false);
  const [editNode, setEditNode] = useState(null);
  const [nodeForm, setNodeForm] = useState({ node_key: '', label: '', node_type: 'equipment', signal_name: '' });
  const [customNodeType, setCustomNodeType] = useState('');
  const [edgeForm, setEdgeForm] = useState({ from_node_key: '', to_node_key: '', flow_signal: '' });
  const canvasRef = React.useRef(null);
  const NODE_TYPES = ['tank', 'pump', 'vessel', 'exchanger', 'compressor', 'valve', 'output', 'equipment', 'custom'];

  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const loadFlow = async (cid) => {
    if (!cid) return;
    try {
      const r = await fetch(`${API_URL}/process-flow?customer_id=${cid}`, { headers });
      const d = await r.json();
      setNodes(d.nodes || []);
      setEdges(d.edges || []);
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  const loadSignals = async (cid) => {
    if (!cid) return;
    try {
      const r = await fetch(`${API_URL}/signals/metadata?customer_id=${cid}`, { headers });
      const d = await r.json();
      setSignals((d.signals || []).map(s => s.signal_name));
    } catch(e) {}
  };

  const selectCustomer = (cid) => {
    setCustomerId(cid);
    setNodes([]); setEdges([]);
    loadFlow(cid);
    loadSignals(cid);
  };

  const saveNode = async () => {
    if (!nodeForm.node_key || !nodeForm.label) return setMsg({ type: 'error', text: 'Node key and label required' });
    try {
      const r = await fetch(`${API_URL}/process-flow/nodes`, {
        method: 'POST', headers,
        body: JSON.stringify({ ...nodeForm, customer_id: customerId,
          pos_x: editNode ? editNode.pos_x : 200,
          pos_y: editNode ? editNode.pos_y : 200,
          sort_order: nodes.length })
      });
      if (r.ok) {
        setMsg({ type: 'success', text: `Node "${nodeForm.label}" saved` });
        setShowNodeForm(false); setEditNode(null);
        setNodeForm({ node_key: '', label: '', node_type: 'equipment', signal_name: '' });
        loadFlow(customerId);
      } else { const d = await r.json(); setMsg({ type: 'error', text: d.error }); }
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  const deleteNode = async (node_key) => {
    if (!window.confirm(`Delete node "${node_key}" and its connections?`)) return;
    try {
      await fetch(`${API_URL}/process-flow/nodes/${node_key}`, {
        method: 'DELETE', headers,
        body: JSON.stringify({ customer_id: customerId })
      });
      loadFlow(customerId);
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  const saveEdge = async () => {
    if (!edgeForm.from_node_key || !edgeForm.to_node_key) return setMsg({ type: 'error', text: 'Select both nodes' });
    try {
      const r = await fetch(`${API_URL}/process-flow/edges`, {
        method: 'POST', headers,
        body: JSON.stringify({ ...edgeForm, customer_id: customerId, sort_order: edges.length })
      });
      if (r.ok) {
        setMsg({ type: 'success', text: 'Connection saved' });
        setShowEdgeForm(false);
        setEdgeForm({ from_node_key: '', to_node_key: '', flow_signal: '' });
        loadFlow(customerId);
      }
    } catch(e) { setMsg({ type: 'error', text: e.message }); }
  };

  const deleteEdge = async (from, to) => {
    try {
      await fetch(`${API_URL}/process-flow/edges`, {
        method: 'DELETE', headers,
        body: JSON.stringify({ customer_id: customerId, from_node_key: from, to_node_key: to })
      });
      loadFlow(customerId);
    } catch(e) {}
  };

  // Drag handlers
  const onMouseDown = (e, node) => {
    e.preventDefault();
    const canvas = canvasRef.current.getBoundingClientRect();
    setDragging(node.node_key);
    setDragOffset({ x: e.clientX - canvas.left - node.pos_x, y: e.clientY - canvas.top - node.pos_y });
  };

  const onMouseMove = (e) => {
    if (!dragging) return;
    const canvas = canvasRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(700, e.clientX - canvas.left - dragOffset.x));
    const y = Math.max(0, Math.min(400, e.clientY - canvas.top - dragOffset.y));
    setNodes(prev => prev.map(n => n.node_key === dragging ? { ...n, pos_x: x, pos_y: y } : n));
  };

  const onMouseUp = async () => {
    if (!dragging) return;
    const node = nodes.find(n => n.node_key === dragging);
    if (node) {
      await fetch(`${API_URL}/process-flow/positions`, {
        method: 'POST', headers,
        body: JSON.stringify({ customer_id: customerId, positions: [{ node_key: node.node_key, pos_x: node.pos_x, pos_y: node.pos_y }] })
      });
    }
    setDragging(null);
  };

  const nodeColor = (type) => ({
    tank: '#1a3a5c', pump: '#1a4a2a', vessel: '#3a2a1a', exchanger: '#2a1a4a',
    compressor: '#1a4a4a', valve: '#4a3a1a', output: '#2a2a2a', equipment: '#1e2130'
  }[type] || '#1e2130');

  const severityColor = (sev) => ({
    critical: '#e53e3e', alarm: '#ed8936', warning: '#ecc94b', normal: '#48bb78'
  }[sev] || '#4a9eff');

  // Draw SVG edges
  const renderEdges = () => edges.map((e, i) => {
    const from = nodes.find(n => n.node_key === e.from_node_key);
    const to   = nodes.find(n => n.node_key === e.to_node_key);
    if (!from || !to) return null;
    const x1 = from.pos_x + 60, y1 = from.pos_y + 30;
    const x2 = to.pos_x + 60,   y2 = to.pos_y + 30;
    const mx = (x1 + x2) / 2;
    return (
      <g key={i}>
        <path d={`M${x1},${y1} C${mx},${y1} ${mx},${y2} ${x2},${y2}`}
          stroke="#4a9eff" strokeWidth="2" strokeDasharray="6,3" fill="none" opacity="0.7"/>
        <circle cx={mx} cy={(y1+y2)/2} r="6" fill="#1e2130" stroke="#4a9eff" strokeWidth="1.5"
          style={{cursor:'pointer'}} onClick={() => deleteEdge(e.from_node_key, e.to_node_key)}/>
        <text x={mx} y={(y1+y2)/2+4} textAnchor="middle" fill="#e53e3e" fontSize="10" style={{cursor:'pointer'}}
          onClick={() => deleteEdge(e.from_node_key, e.to_node_key)}>×</text>
      </g>
    );
  });

  const s = {
    wrap: { background: '#0f1117', borderRadius: '8px', padding: '1rem' },
    canvas: { position: 'relative', background: '#1a1d27', borderRadius: '8px', border: '1px solid #2a2d3e',
      height: '440px', overflow: 'hidden', cursor: dragging ? 'grabbing' : 'default', userSelect: 'none' },
    node: (n) => ({ position: 'absolute', left: n.pos_x, top: n.pos_y, width: '120px',
      background: nodeColor(n.node_type), border: `2px solid ${severityColor(n.signal?.severity || 'normal')}`,
      borderRadius: '8px', padding: '6px 8px', cursor: 'grab', userSelect: 'none' }),
    nodeLabel: { color: '#fff', fontWeight: 600, fontSize: '0.75rem', marginBottom: '2px' },
    nodeSignal: { color: '#aaa', fontSize: '0.65rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    toolbar: { display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap', alignItems: 'center' },
    btn: { background: '#2a2d3e', color: '#e2e8f0', border: '1px solid #3a3d4e', borderRadius: '4px',
      padding: '0.35rem 0.75rem', cursor: 'pointer', fontSize: '0.8rem' },
    btnPrimary: { background: '#4a9eff', color: '#fff', border: 'none', borderRadius: '4px',
      padding: '0.35rem 0.75rem', cursor: 'pointer', fontSize: '0.8rem' },
    form: { background: '#1a1d27', border: '1px solid #2a2d3e', borderRadius: '6px', padding: '1rem', marginBottom: '1rem' },
    input: { background: '#0f1117', border: '1px solid #2a2d3e', color: '#e2e8f0', borderRadius: '4px',
      padding: '0.4rem 0.6rem', fontSize: '0.85rem', width: '100%', boxSizing: 'border-box' },
    select: { background: '#0f1117', border: '1px solid #2a2d3e', color: '#e2e8f0', borderRadius: '4px',
      padding: '0.4rem 0.6rem', fontSize: '0.85rem', width: '100%', boxSizing: 'border-box' },
    label: { color: '#aaa', fontSize: '0.75rem', marginBottom: '3px', display: 'block' },
    row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' },
    edgeTable: { width: '100%', borderCollapse: 'collapse', marginTop: '0.75rem', fontSize: '0.8rem' },
    th: { background: '#1a1d27', color: '#aaa', padding: '0.4rem 0.6rem', textAlign: 'left', borderBottom: '1px solid #2a2d3e' },
    td: { padding: '0.4rem 0.6rem', color: '#e2e8f0', borderBottom: '1px solid #1a1d27' },
  };

  return (
    <div style={s.wrap}>
      {/* Customer selector */}
      {isAdmin && (
        <div style={{ marginBottom: '1rem' }}>
          <label style={s.label}>Customer</label>
          <select style={{ ...s.select, width: '220px' }} value={customerId} onChange={e => selectCustomer(e.target.value)}>
            <option value="">— select customer —</option>
            {customers.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
        </div>
      )}

      {customerId && (<>
        {/* Toolbar */}
        <div style={s.toolbar}>
          <button style={s.btnPrimary} onClick={() => { setShowNodeForm(true); setEditNode(null);
            setNodeForm({ node_key: '', label: '', node_type: 'equipment', signal_name: '' }); }}>
            + Add Node
          </button>
          <button style={s.btn} onClick={() => setShowEdgeForm(true)}>+ Add Connection</button>
          <span style={{ color: '#aaa', fontSize: '0.75rem', marginLeft: '0.5rem' }}>
            Drag nodes to reposition • Click × on a connection to delete it
          </span>
        </div>

        {msg && <div style={{ ...( msg.type === 'success' ? { color: '#48bb78' } : { color: '#e53e3e' }),
          fontSize: '0.85rem', marginBottom: '0.75rem' }}>{msg.text}</div>}

        {/* Node form */}
        {showNodeForm && (
          <div style={s.form}>
            <div style={{ color: '#e2e8f0', fontWeight: 600, marginBottom: '0.75rem' }}>
              {editNode ? 'Edit Node' : 'Add Node'}
            </div>
            <div style={s.row}>
              <div>
                <label style={s.label}>Node Key (unique ID)</label>
                <input style={s.input} placeholder="e.g. feed_pump" value={nodeForm.node_key}
                  onChange={e => setNodeForm({...nodeForm, node_key: e.target.value.replace(/\s/g,'_').toLowerCase()})}/>
              </div>
              <div>
                <label style={s.label}>Label (display name)</label>
                <input style={s.input} placeholder="e.g. Feed Pump" value={nodeForm.label}
                  onChange={e => setNodeForm({...nodeForm, label: e.target.value})}/>
              </div>
            </div>
            <div style={s.row}>
              <div>
                <label style={s.label}>Node Type</label>
                <select style={s.select} value={NODE_TYPES.includes(nodeForm.node_type) ? nodeForm.node_type : 'custom'}
                  onChange={e => {
                    if (e.target.value === 'custom') { setNodeForm({...nodeForm, node_type: customNodeType || ''}); }
                    else { setNodeForm({...nodeForm, node_type: e.target.value}); setCustomNodeType(''); }
                  }}>
                  {NODE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
                {(!NODE_TYPES.includes(nodeForm.node_type) || nodeForm.node_type === 'custom' || customNodeType) && (
                  <input style={{...s.input, marginTop: '4px'}} placeholder="Enter custom type..."
                    value={customNodeType || (NODE_TYPES.includes(nodeForm.node_type) ? '' : nodeForm.node_type)}
                    onChange={e => { setCustomNodeType(e.target.value); setNodeForm({...nodeForm, node_type: e.target.value}); }}/>
                )}
              </div>
              <div>
                <label style={s.label}>Signal (optional)</label>
                <select style={s.select} value={nodeForm.signal_name}
                  onChange={e => setNodeForm({...nodeForm, signal_name: e.target.value})}>
                  <option value="">— none —</option>
                  {signals.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button style={s.btnPrimary} onClick={saveNode}>Save Node</button>
              <button style={s.btn} onClick={() => { setShowNodeForm(false); setEditNode(null); }}>Cancel</button>
            </div>
          </div>
        )}

        {/* Edge form */}
        {showEdgeForm && (
          <div style={s.form}>
            <div style={{ color: '#e2e8f0', fontWeight: 600, marginBottom: '0.75rem' }}>Add Connection</div>
            <div style={s.row}>
              <div>
                <label style={s.label}>From Node</label>
                <select style={s.select} value={edgeForm.from_node_key}
                  onChange={e => setEdgeForm({...edgeForm, from_node_key: e.target.value})}>
                  <option value="">— select —</option>
                  {nodes.map(n => <option key={n.node_key} value={n.node_key}>{n.label}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>To Node</label>
                <select style={s.select} value={edgeForm.to_node_key}
                  onChange={e => setEdgeForm({...edgeForm, to_node_key: e.target.value})}>
                  <option value="">— select —</option>
                  {nodes.map(n => <option key={n.node_key} value={n.node_key}>{n.label}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <label style={s.label}>Flow Signal (optional)</label>
              <select style={{ ...s.select, width: '50%' }} value={edgeForm.flow_signal}
                onChange={e => setEdgeForm({...edgeForm, flow_signal: e.target.value})}>
                <option value="">— none —</option>
                {signals.map(sig => <option key={sig} value={sig}>{sig}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button style={s.btnPrimary} onClick={saveEdge}>Save Connection</button>
              <button style={s.btn} onClick={() => setShowEdgeForm(false)}>Cancel</button>
            </div>
          </div>
        )}

        {/* Canvas */}
        <div ref={canvasRef} style={s.canvas}
          onMouseMove={onMouseMove} onMouseUp={onMouseUp} onMouseLeave={onMouseUp}>
          <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
            <defs>
              <marker id="arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
                <path d="M0,0 L0,6 L8,3 z" fill="#4a9eff" opacity="0.7"/>
              </marker>
            </defs>
            <g style={{ pointerEvents: 'all' }}>
              {renderEdges()}
            </g>
          </svg>
          {nodes.map(n => (
            <div key={n.node_key} style={s.node(n)} onMouseDown={e => onMouseDown(e, n)}>
              <div style={s.nodeLabel}>{n.label}</div>
              <div style={s.nodeSignal}>{n.node_type}</div>
              {n.signal_name && <div style={{...s.nodeSignal, color: '#4a9eff'}}>{n.signal_name}</div>}
              <div style={{ display: 'flex', gap: '4px', marginTop: '6px' }}>
                <button style={{ fontSize: '0.7rem', cursor: 'pointer', color: '#ccc', background: '#2a2d3e',
                  border: '1px solid #3a3d4e', borderRadius: '3px', padding: '2px 6px', lineHeight: 1.4 }}
                  onMouseDown={e => { e.stopPropagation(); e.preventDefault(); }}
                  onClick={(e) => { e.stopPropagation(); setEditNode(n); setShowNodeForm(true);
                    setNodeForm({ node_key: n.node_key, label: n.label, node_type: n.node_type, signal_name: n.signal_name || '' }); }}>
                  Edit
                </button>
                <button style={{ fontSize: '0.7rem', cursor: 'pointer', color: '#e53e3e', background: '#2a2d3e',
                  border: '1px solid #3a3d4e', borderRadius: '3px', padding: '2px 6px', lineHeight: 1.4 }}
                  onMouseDown={e => { e.stopPropagation(); e.preventDefault(); }}
                  onClick={(e) => { e.stopPropagation(); deleteNode(n.node_key); }}>
                  Del
                </button>
              </div>
            </div>
          ))}
          {nodes.length === 0 && (
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
              color: '#444', textAlign: 'center', fontSize: '0.9rem' }}>
              No nodes yet — click "Add Node" to start building the flow diagram
            </div>
          )}
        </div>

        {/* Edge list */}
        {edges.length > 0 && (
          <div style={{ marginTop: '1rem' }}>
            <div style={{ color: '#aaa', fontSize: '0.8rem', marginBottom: '0.5rem' }}>Connections ({edges.length})</div>
            <table style={s.edgeTable}>
              <thead>
                <tr>
                  <th style={s.th}>From</th>
                  <th style={s.th}>To</th>
                  <th style={s.th}>Flow Signal</th>
                  <th style={s.th}></th>
                </tr>
              </thead>
              <tbody>
                {edges.map((e, i) => (
                  <tr key={i}>
                    <td style={s.td}>{nodes.find(n=>n.node_key===e.from_node_key)?.label || e.from_node_key}</td>
                    <td style={s.td}>{nodes.find(n=>n.node_key===e.to_node_key)?.label || e.to_node_key}</td>
                    <td style={s.td}>{e.flow_signal || '—'}</td>
                    <td style={s.td}>
                      <span style={{ color: '#e53e3e', cursor: 'pointer', fontSize: '0.8rem' }}
                        onClick={() => deleteEdge(e.from_node_key, e.to_node_key)}>Delete</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>)}
    </div>
  );
}
